import { FC } from 'react';

export interface ProntoLogoExpandedProps {
  height?: number | string;
  fill?: string;
}

const ProntoLogoExpanded: FC<ProntoLogoExpandedProps> = ({
  height,
  fill = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 610.8 150.3"
    style={{
      height:
        height != null
          ? typeof height === 'number'
            ? `${height}px`
            : height
          : undefined,
      fill,
    }}
    aria-hidden
  >
    <g>
      <path d="M0,0v150.3h124.4V0H0ZM12.1,12.1h68.7v91.8l-68.7,27s0-118.8,0-118.8ZM112.3,138.3H26.4l66.5-26.1V12.1h19.4v126.2Z" />
      <path d="M194.7,16.5h-22v60.8h12.1v-18.9h11.7c16,0,24.4-7.3,24.4-21s-9.6-20.9-26.2-20.9ZM195.3,49h-10.6v-22.1h9.7c12.9,0,14.3,6.2,14.3,10.8,0,7.6-4.4,11.3-13.5,11.3h.1Z" />
      <path d="M280.4,77.3h13.5l-14.8-24v-.8h.3c6.2-3.1,9.7-9,9.7-16.6,0-12.4-8.8-19.5-24.2-19.5h-23.1v60.9h12.1v-22.4h12.4l14.1,22.4ZM253.9,46v-19.3h10.8c8.4,0,12.4,3,12.4,9.5s-3.9,9.7-13.1,9.7h-10l-.1.1Z" />
      <path d="M341.8,15.3c-18.9,0-33.1,13.4-33.1,31.2s13.6,31.9,33.1,31.9,33.1-13.1,33.1-31.9-14.2-31.2-33.1-31.2ZM341.8,67.5c-12.3,0-20.3-8.2-20.3-20.9s8.5-20.4,20.3-20.4,20.3,8.6,20.3,20.4c0,12.7-7.9,20.9-20.3,20.9Z" />
      <path d="M442,77.3h11.5V16.5h-12.1v27.5c0,3.5.8,13,.8,13.1v.6h-1l-33.6-41.2h-11.7v60.8h12.1v-26.7c0-4.6-.8-14.1-.8-14.2v-.6h1l33.9,41.4-.1.1Z" />
      <polygon points="530 16.5 472.4 16.5 472.4 27.1 495.2 27.1 495.2 77.3 507.3 77.3 507.3 27.1 530 27.1 530 16.5" />
      <path d="M577.7,15.3c-18.9,0-33.2,13.4-33.2,31.2s13.6,31.9,33.2,31.9,33.1-13.1,33.1-31.9c0-17.8-14.3-31.2-33.1-31.2ZM577.7,67.5c-12.3,0-20.3-8.2-20.3-20.9s8.5-20.4,20.3-20.4,20.3,8.6,20.3,20.4c0,12.7-8,20.9-20.3,20.9Z" />
      <path d="M178,98.4v14.9h19.7v-14.9h5.4v36h-5.4v-16.3h-19.7v16.3h-5.4v-36h5.4Z" />
      <path d="M254.2,116.2c0,10.8-7.8,18.9-19.1,18.9s-19.1-7.5-19.1-18.9,8.4-18.4,19.1-18.4,19.1,8,19.1,18.4ZM221.5,116.2c0,9,5.9,14.1,13.6,14.1s13.6-5.1,13.6-14.1-5.9-13.6-13.6-13.6-13.6,5.5-13.6,13.6h0Z" />
      <path d="M298.8,98.4v22.2c0,9.8-7.5,14.4-16,14.4s-16-4.6-16-14.4v-22.2h5.4v22.2c0,5.9,3.5,9.6,10.7,9.6s10.6-3.8,10.6-9.6v-22.2h5.4-.1Z" />
      <path d="M311.6,131.9l1.8-4.6c3.7,1.8,7.8,2.8,11.9,2.9,6.2,0,9.2-2.8,9.2-6.4,0-1.6-.8-3-2.2-3.8-1.4-.9-4-1.4-7.4-1.8-3.8-.4-6.6-1-8.9-2.2-3-1.5-4.8-4.5-4.6-7.8,0-5.9,5.6-10.4,13.7-10.4,4.3,0,8.5.8,12.4,2.6l-1.8,4.5c-3.4-1.4-7-2.2-10.7-2.3-6.3,0-8.4,2.9-8.4,5.6,0,1.6.9,3,2.3,3.7,1.4.8,3.6,1.1,7,1.5,3.5.5,6.8,1.1,8.8,2.2,3.1,1.5,5,4.7,4.8,8.1,0,6.3-5.4,11.3-14.3,11.3-4.8.2-9.5-.9-13.7-3.1h.1Z" />
      <path d="M357.8,98.4v36h-5.4v-36h5.4Z" />
      <path d="M400.4,98.4h5.4v36h-4.8l-22.4-27.5h-.1s.5,6.2.5,9.1v18.4h-5.4v-36h4.8l22.4,27.5h.1s-.5-6.3-.5-8.4v-19.1Z" />
      <path d="M424.1,116.6c0,8.4,6,13.6,12.6,13.6s9.3-2.2,10.8-3.7v-6.5h-10v-4.5h15.4v18.8h-3.8l-1.5-4.2h-.4c-2.7,3.9-6,4.9-10.6,4.9-11.6,0-18-8.1-18-18.4s7.7-18.9,18.9-18.9,11.6,2.7,14.2,5.1l-2.6,4.2c-3.5-2.7-6.8-4.4-11.6-4.4-8.5,0-13.5,5.9-13.5,14h.1Z" />
    </g>
  </svg>
);

export default ProntoLogoExpanded;
